import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Nezadovoljstva",
  "description": "",
  "published": "2007-06-19T00:00:00.000Z",
  "redirect_from": ["/blog/nezadovoljstva/swizec/185"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`ÄŒe mi je bil Kubntu še tako`}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=news/id=238"
      }}>{` všeÄ`}</a>{` in sem mislil, da bo pravi sistem za vsakodnevno delo, je bilo preveÄ problemov, ki me, ponovno, silijo v menjavo pingvinov, ki poganjajo zobnike mojega diferenÄnega stroja.`}</p>
    <p>{`Eden takih velikih problemov je bila popolna nezmoÅ¾nost nastavitve mojega Wacoma za delo s Photoshop 7 ali celo popolnoma virtualno verzijo Windowsov. Preprosto ni delalo in ker poÄnem veliko grafiÄnih umetniÄarij, si tega preprosto ne morem privošÄiti. Drug problem je bila velika teÅ¾ava z nastavitvijo poÅ¾arnega zidu, saj Kubuntu iz neznanih razlogov ni zaganjal iptables pri vsakem zagonu. Nepredstavljivo.`}</p>
    <p>{`Zatorej danes zaÄenjam selitev nazaj na Gentoo, kar bi moral storiti Å¾e vÄeraj pa nekako nisem. Škoda je le, da ta migracija traja nekako tri dni, ampak bo vsaj raÄunalo neuporabno in se bom laÅ¾je uÄil.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      